// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5352e33d","952":"5844cd3e"}[chunkId] + ".chunk.js";
};